export const buttonData = {
  film: 'watch film',
  cta: 'learn more',
  share: 'copied to clipboard'
};
